import { ReactComponent as StatusFailedIcon } from 'assets/images/elearning/topic-status/status_failed.svg';
import { ReactComponent as StatusSuccessIcon } from 'assets/images/elearning/topic-status/status_success.svg';
import clsx from 'clsx';
import { Button } from 'components/universal/button';
import Heading from 'components/universal/heading';
import Paragraph from 'components/universal/paragraph';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import cls from './topic-status.module.scss';

type Title =
    | 'Temat ukończony!'
    | 'Nie udało się'
    | 'Szkolenie ukończone!'
    | 'GRATULACJE'
    | 'Ten temat jest jeszcze zablokowany';
type ButtonText =
    | 'PRZEJDŹ DO KOLEJNEGO TEMATU'
    | 'SPRÓBUJ PONOWNIE'
    | 'ROZPOCZNIJ QUIZ'
    | 'ZAKOŃCZ SZKOLENIE'
    | 'PRZEJDŹ DO AKTUALNEGO TEMATU';
interface IProps {
    title: Title;
    description?: string;
    buttonText: ButtonText;
    obtainedPoints?: number;
    maxScore?: number;
    isSuccess?: boolean;
    isStandalone?: boolean;
    isHideStatusIcon?: boolean;
    onSubmit: () => void;
    className?: string;
    isQuiz?: boolean | undefined;
    taskType?: string | undefined;
}

export const TopicStatus: FC<IProps> = ({
    title,
    description,
    buttonText,
    obtainedPoints,
    maxScore,
    isSuccess,
    isHideStatusIcon,
    isStandalone = false,
    onSubmit,
    className,
    isQuiz,
    taskType
}) => {
    const { t } = useTranslation('', {
        keyPrefix: 'components.topicStatusWithButton',
    });
    const clsWrapper = clsx(cls.wrapper, {
        [className]: Boolean(className),
    });

    const clsContainer = clsx(cls.container, {
        [cls.containerStandalone]: isStandalone,
    });

    return (
        <div className={clsContainer}>
            <div className={clsWrapper}>
                <div className={cls.infoWrapper}>
                    {(taskType !== 'challenge_match_image_with_description' && taskType !== 'challenge_match_text_with_images') &&
                        <Heading className={cls.heading} headingLevel="h3">
                            {!isHideStatusIcon && (
                                <div>
                                    {isSuccess ? (
                                        <StatusSuccessIcon />
                                    ) : (
                                        <StatusFailedIcon />
                                    )}
                                </div>
                            )}
                            {title}
                        </Heading>
                    }

                    {(description && !isQuiz && taskType !== 'challenge_match_image_with_description' && taskType !== 'challenge_match_text_with_images') && (
                        <Paragraph className={cls.paragraph}>{description}</Paragraph>
                    )}

                    {isQuiz && <Paragraph className={cls.paragraph}>
                        {description ? (
                            description
                        ) : (
                            <>
                                {t('correctAnswerText1')}{' '}
                                <b>
                                    {obtainedPoints}/{maxScore}
                                </b>{' '}
                                {t('correctAnswerText2')}
                            </>
                        )}
                    </Paragraph>}
                    
                    <Button className={cls.resetButotn} onClick={onSubmit}>{buttonText}</Button>
                </div>
            </div>
        </div>
    );
};
